import g10Logo from './images/g10-logo.png'
import g10WhiteLogo from './images/g10-logo-white.png'
import g10Svg from './images/g10-transportes.svg'
import tpLogo from './images/logo-tp.png'
import tpLogoWhite from './images/logo-tp-white.svg'
import tpSvg from './images/logo-tp.svg'

const company = process.env.REACT_APP_COMPANY || 'g10'

const branding = {
  g10: {
    name: 'G10',
    displayName: 'G10 Transportes',
    label: 'g10',
    logo: g10Logo,
    svg: g10Svg,
    alternative: g10WhiteLogo,
    cnpj: '07.569.161/0001-40',
    address: 'Rodovia PR 317, nº 4652',
    cep: '87035-510',
    city: 'Maringá-PR'
  },
  tp: {
    name: 'TP',
    displayName: 'Transpanorama',
    label: 'tp',
    logo: tpLogo,
    svg: tpSvg,
    alternative: tpLogoWhite,
    cnpj: '01.937.440/0001-32',
    address: 'Rodovia Pr 317, Km3, 4652',
    cep: '87035-510',
    city: 'Maringá-PR'
  }
}

export const BRAND = branding[company]
